import {
  EC2Client,
  DescribeTrafficMirrorTargetsCommand,
  CreateTrafficMirrorTargetCommand,
  DeleteTrafficMirrorTargetCommand,
  DescribeNetworkInterfacesCommand,
  DescribeInstancesCommand,
} from "@aws-sdk/client-ec2";

const fields = [
  {
    variable: "Description",
    hidden: false,
    title: "Target Description",
    field: "Description",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "Type",
    hidden: false,
    title: "Target Type",
    field: "Type",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "NetworkInterfaceId",
    hidden: false,
    title: "Target Destination",
    field: "NetworkInterfaceId",
    defaultSort: "asc",
    type: "string",
  },
];

class TargetService {
  constructor(config) {
    this.config = config;
    this.searchPlaceholder = "Search Mirror Target";
    this.ec2Client = new EC2Client(this.config);
  }

  getTargets = async () => {
    try {
      const command = new DescribeTrafficMirrorTargetsCommand();
      const response = await this.ec2Client.send(command);
      return response.TrafficMirrorTargets;
    } catch (error) {
      console.error("Error fetching targets:", error);
      return null;
    }
  };

  getTargetById = async (targetId) => {
    let input = {};
    try {
      if (targetId) {
        input = { TrafficMirrorTargetIds: [targetId], DryRun: false };
      }
      const command = new DescribeTrafficMirrorTargetsCommand(input);
      const response = await this.ec2Client.send(command);
      return response.TrafficMirrorTargets;
    } catch (error) {
      console.error("Error fetching Target By ID:", error);
      return null;
    }
  };

  createTarget = async (target) => {
    let input = {};
    try {
      if (target) {
        input = { ...target };
        delete input.TrafficMirrorTargetId;
        if (input.Type === "network-interface") {
          delete input.GatewayLoadBalancerEndpointId;
          delete input.NetworkLoadBalancerArn;
        } else if (input.Type === "network_load_balancer") {
          delete input.GatewayLoadBalancerEndpointId;
          delete input.NetworkInterfaceId;
        } else if (input.Type === "gateway_load_balancer_endpoint") {
          delete input.NetworkLoadBalancerArn;
          delete input.NetworkInterfaceId;
        }
      }
      const command = new CreateTrafficMirrorTargetCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error creating target:", error);
      return error;
    }
  };

  deleteTarget = async (targetId) => {
    let input = {};
    try {
      if (targetId) {
        input = { TrafficMirrorTargetId: targetId, DryRun: false };
      }
      const command = new DeleteTrafficMirrorTargetCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error deleting target:", error);
      return error;
    }
  };

  getNetworkInterfaces = async (type) => {
    let input = {};
    try {
      if (type) {
        if (type === "network-interface") {
          input = {
            Filters: [{ Name: "interface-type", Values: ["interface"] }],
          };
        } else {
          input = { Filters: [{ Name: "interface-type", Values: [type] }] };
        }
      }
      const command = new DescribeNetworkInterfacesCommand(input);
      const response = await this.ec2Client.send(command);
      return response.NetworkInterfaces;
    } catch (error) {
      console.error("Error fetching filters:", error);
      return error;
    }
  };
  getInstances = async(networkId) =>{
    let input = {};
    try{
      if (networkId){
        input = { 
          Filters: [
            {
              Name: "network-interface.network-interface-id",
              Values: [networkId],
            },
          ],
          DryRun: false,
        };
      }
      const command = new DescribeInstancesCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch(error){
      console.error("Error fetching instance:", error);
      return error;
    }
  }
}

export { TargetService as default, fields };
